import { render, staticRenderFns } from "./StaffLeaveEntitlement.vue?vue&type=template&id=61bfbc3e&scoped=true&"
import script from "./StaffLeaveEntitlement.vue?vue&type=script&lang=js&"
export * from "./StaffLeaveEntitlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bfbc3e",
  null
  
)

export default component.exports